module.exports = __webpack_public_path__ + "static/media/v.428ad7f1.png";